export default __webpack_public_path__ + "static/media/camera-add.a8504d3d.svg";